module.exports = __webpack_public_path__ + "static/media/harveen-profile.0565355e.jpg";